import {
    SUBMIT_NUDGES_NEW_REQUEST,
    SUBMIT_NUDGES_NEW_SUCCESS,
    SUBMIT_NUDGES_NEW_FAILURE,
  } from "../actions/NudgesNewActions";
  
  const initialState = {
    loading: false,
    successMessage: null,
    errorMessage: null,
  };
  
  const nudgesNewReducer = (state = initialState, action) => {
    switch (action.type) {
      case SUBMIT_NUDGES_NEW_REQUEST:
        return {
          ...state,
          loading: true,
          successMessage: null,
          errorMessage: null,
        };
      case SUBMIT_NUDGES_NEW_SUCCESS:
        return {
          ...state,
          loading: false,
          successMessage: action.payload,
          errorMessage: null,
        };
      case SUBMIT_NUDGES_NEW_FAILURE:
        return {
          ...state,
          loading: false,
          successMessage: null,
          errorMessage: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default nudgesNewReducer;